import React, { useState, useEffect } from 'react';
import { get_events, get_future_events, get_future_events_with_filters, create_cal_event } from '../../services/events_service'
import './events.css'
import { PageIntro, ErrLoadingMsg, GetInvolvedMsg } from '../Templates'
import { EventView } from '../EventTemplate';

const NoEventsMsg = () => {
    return (
        <section className="events">
            <p className="text_container">No events are posted here right now. Check later or visit our Instagram <a href="https://www.instagram.com/olivetreesolidarity_/">@olivetreesolidarity</a> for future events!</p>
        </section>
    )
}

const SingleEvent = ({ event }) => {

    const [datetime, setDatetime] = useState('')
    const [timeText, setTimeText] = useState('')

    useEffect(() => {
        const start_time = new Date(event.start_time)
        setDatetime(`${start_time.getYear()}-${start_time.getMonth()}-${start_time.getDate()}`)
        setTimeText(`${start_time.toLocaleDateString("en-US", { month: 'long' })} ${start_time.getDate()}`)
    }, [event])

    return (
        <React.Fragment>
            <header className="event">
                <h3 className="event">&sect; &nbsp; <time datetime={datetime}>{timeText}</time>: {event.summary}</h3>
            </header>
            <EventView otsevent={event} />
        </React.Fragment>
    )
}

const Events = () => {


    const [data, setData] = useState([])
    const [noEventsPosted, setNoEventsPosted] = useState(null)
    const [loadingError, setLoadingError] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            const resp = await get_future_events_with_filters({ is_published: true })
            if (resp.status !== 200) {
                throw new Error(`HTTP error! status: ${resp.status}`);
            }
            setData(resp.data)
            if (resp.data.length === 0) {
                setNoEventsPosted(true)
            }
        } catch (err) {
            console.log(`loadingError caught: ${err}`)
            setLoadingError(err)
        } finally {
            setLoading(false)
        }
        // setLoading(true)
        // setLoadingError('error')
    }

    useEffect(() => {
        fetchData()

        // setNoEventsPosted(true)
        // setLoadingError('err')
    }, [])

    return (
        <React.Fragment>
            <h1>Upcoming Events</h1>
            <PageIntro>OTS hosts events and actions where we can disrupt, network, and learn together.</PageIntro>
            <section className="content-box">
                {loading === true ? (<h1>loading</h1>) :
                    (loadingError ? (<ErrLoadingMsg />) :
                        (noEventsPosted === true ? (<NoEventsMsg />) :
                            (<React.Fragment>
                                {data.map((event, i) => (<div index={i} className="event-container">
                                    <SingleEvent event={event} />
                                </div>))}
                            </React.Fragment>)
                        )
                    )
                }
            </section>
            <hr />
            <section className="content-box">
                <GetInvolvedMsg />
            </section>
        </React.Fragment>
    )
}

export default Events;